import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExternalLinkService {
  constructor() { 
  }

  isExternalLink(url: string): boolean {
    try {
      const linkUrl = new URL(url, window.location.origin); 
      console.log('Parsed URL Origin:', linkUrl.origin);
      console.log('Current Site Origin:', window.location.origin);

      //1 Check if URL is same-origin (internal)
      if (linkUrl.origin === window.location.origin) {
        return false; // Internal link
      }

      //1 Check if URL is in the trusted list (whitelist)
      if (environment.KNOWN_SITES.some(site => linkUrl.origin.startsWith(site))) {
        console.log(`Whitelisted Site: ${linkUrl.origin}`);
        return false; // Considered safe
      }

      //3 If not internal and not whitelisted, it's external
      return true;

    } catch (error){
      console.error('Error Parsing URL:', error);
      return false; // If URL is malformed, assume it's internal
    }
  }
}
